import React from 'react';
import {
    Dialog,
    IconButton,
    useMediaQuery,
    useTheme,
    DialogProps,
} from '@mui/material';

type ModalProps = DialogProps & {
    id?: string;
    open: boolean;
    children?: React.ReactNode;
};

export const Modal: React.FC<ModalProps> = ({
    id,
    open,
    onClose,
    children,
    ...dialogProps
}) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down(800));
    return (
        <Dialog
            {...dialogProps}
            data-testid={`dialog-rooot-${id}`}
            open={open}
            onClose={onClose}
            container={document.getElementById('root')}
            maxWidth="sm"
            fullScreen={isMobile}
            sx={{
                '& .MuiBackdrop-root': { backgroundColor: '#f1f0f7cc' },
                '& .MuiDialog-paper': {
                    borderRadius: isMobile ? 0 : '24px',
                    padding: '48px 24px',
                    backgroundColor: '#ffffff',
                    boxShadow:
                        '0 1px 6px 0 rgba(10, 0, 77, 0.04), 0 5.5px 30px 0 rgba(10, 0, 77, 0.05)',
                    minWidth: 320,
                    position: 'relative',
                },
            }}
        >
            <div
                data-testid={`dialog-content-${id}`}
                className="flex flex-col items-center gap-8 pt-2"
            >
                <IconButton
                    data-testid="change-password-dialog-close"
                    className="absolute right-3 top-3"
                    onClick={() => onClose?.({}, 'escapeKeyDown')}
                >
                    <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M12 2.25C17.3848 2.25 21.75 6.61522 21.75 12C21.75 17.3848 17.3848 21.75 12 21.75C6.61522 21.75 2.25 17.3848 2.25 12C2.25 6.61522 6.61522 2.25 12 2.25ZM12 3.75C7.44365 3.75 3.75 7.44365 3.75 12C3.75 16.5563 7.44365 20.25 12 20.25C16.5563 20.25 20.25 16.5563 20.25 12C20.25 7.44365 16.5563 3.75 12 3.75ZM14.8467 8.03906C15.1378 7.74238 15.6152 7.74022 15.9092 8.03418C16.1989 8.32414 16.201 8.79318 15.9141 9.08594L13.0576 12L15.9141 14.9141C16.201 15.2068 16.1989 15.6759 15.9092 15.9658C15.6152 16.2598 15.1378 16.2576 14.8467 15.9609L12 13.0576L9.15332 15.9609C8.86217 16.2576 8.38478 16.2598 8.09082 15.9658C7.80106 15.6759 7.79897 15.2068 8.08594 14.9141L10.9424 12L8.03906 9.15332C7.74236 8.86217 7.74021 8.38479 8.03418 8.09082C8.32415 7.80104 8.79317 7.79895 9.08594 8.08594L12 10.9424L14.8467 8.03906Z"
                            fill="#6A6873"
                        />
                    </svg>
                </IconButton>
                {children}
            </div>
        </Dialog>
    );
};
